import {
  DiscountTax,
  TotalTaxExcludingDicountTax,
  TotalTax,
  positive,
} from "../../../api/payment/Utilities";
import { calculator } from "./../../../api/services/PriceCalculatorService";
import { calcLoyaltyPoints } from "../../../api/helpers/LoyalityHelper.js";
import { couponCalculator } from "./../../../api/services/CouponCalculatorService";
import {
  findSameItem,
  calcTotalPrice,
} from "../../../api/helpers/shoppingCartHelper";
import { ConvertToShortHandState } from "../../../api/helpers/stringHelper";
import { addressParse } from "../../../api/helpers/doorDashHelper";
import {
  priceTriggerDiscountsSum,
  rollIntoPriceSum,
} from "../../../api/helpers/priceTriggerHelpers";
import { distanceMatrixApi } from "./../../../api/distanceMatrixApi";
import { doorDash } from "./../../../api/doorDashDelveryFeeApi";
import { Duration } from "luxon";

export const state = {
  cartItems: [],
  currentstore: null,
  deliveryAddress: null,
  isDelivery: null,
  isPickup: null,
  coupons: [],
  couponStoreIds: [],
  priceTriggerOutcomes: [],
  forceUpdate: false,
  distance: 0,
  duration: 0,
  doorDashDeliveryFee: 0,
  deliveryAddressMessage: null,
  scheduledDeliveryTime: null,
  userInfo: null,
  selectedCompanyAddress: null,
  showDeliveryFee: false,
  isUpdateDeliverAddress: true,
  cartItemRepository: {},
  subsidyFee: 0,
  lastRequestDateTime: null,
  deliveryIsLoading: false,
  popularStatus: true,
};

export const mutations = {
  setPopularStatus(state, popularStatus) {
    state.popularStatus = popularStatus;
  },
  setLastRequestDateTime(state, dateTime) {
    state.lastRequestDateTime = dateTime;
  },
  setDeliveryIsLoading(state, loading) {
    state.deliveryIsLoading = loading;
  },
  setIsDelivery(state, isDelivery) {
    state.isDelivery = isDelivery;
  },
  setIsPickup(state, isPickup) {
    state.isPickup = isPickup;
  },
  setSubsidyFee(state, fee) {
    state.subsidyFee = fee;
  },
  setStore(state, payload) {
    state.currentstore = payload;
  },
  setDeliveryAddress(state, payload) {
    state.deliveryAddress = JSON.parse(JSON.stringify(payload));
  },
  setScheduledDeliveryTime(state, payload) {
    state.scheduledDeliveryTime = payload;
  },
  setDoorDashDeliveryFee(state, payload) {
    state.doorDashDeliveryFee = payload;
  },
  setDistance(state, payload) {
    state.distance = payload;
  },
  setDuration(state, payload) {
    state.duration = payload;
  },
  setDeliveryAddressMessage(state, payload) {
    state.deliveryAddressMessage = payload;
  },
  setSelectedCompanyAddress(state, payload) {
    state.selectedCompanyAddress = payload;
  },
  setShowDeliveryFee(state, payload) {
    state.showDeliveryFee = payload;
  },
  setIsUpdateDeliverAddress(state, payload) {
    state.isUpdateDeliverAddress = payload;
  },
  AddCartItemsToRepository(state, payload) {
    state.cartItemRepository[payload.storeId] = {
      cartItems: payload.cartItems,
      currentMenuId: payload.currentMenuId,
    };
  },
  RemoveCartItemsFromRepository(state, payload) {
    state.cartItemRepository[payload.storeId] = null;
  },
  Add_ProductItem(
    state,
    {
      item,
      quantity,
      ProductCategoryIDs,
      ProductTagIDs,
      modifiers,
      PreparationTime,
    }
  ) {
    let now = new Date();
    const records = state.cartItems.filter((element) => element.id == item.id);
    let same = true;
    let find = null;
    if (records.length > 0) {
      find = findSameItem(item, modifiers, records);
      if (!find) {
        same = false;
      }
    } else {
      same = false;
    }
    if (!same) {
      state.cartItems.push({
        ...item,
        modifiers: modifiers,
        quantity,
        ProductCategoryIDs,
        ProductTagIDs,
        created: now.toUTCString(),
        PreparationTime: PreparationTime,
      });
    } else {
      find.quantity += quantity;
      // if (find.modifiers) {
      //   find.modifiers.map(md => {
      //       md.quantity += modifiers.filter(m => m.ID === md.ID)[0].quantity;
      //   });
      // }

      find.created = new Date().toUTCString();
    }
  },
  Set_Items(state, items) {
    if (items) {
      state.cartItems = items;
    }
  },
  REMOVE_CART_ITEM(state, { item }) {
    const record = state.cartItems.find((element) => element.id == item.id);
    state.cartItems.splice(state.cartItems.indexOf(record), 1);
  },
  UpdateQuantity(state, { item, quantity }) {
    let records = state.cartItems.filter((element) => element.id == item.id);
    if (records.length == 0) {
      records = state.cartItems.filter((element) => element.id == item.hQID);
    }
    let same = true;
    let find = null;
    if (records.length > 0) {
      find = findSameItem(item, item.modifiers, records);
      if (!find) {
        same = false;
      }
      //
      if (same) {
        //let now = new Date();
        find.quantity = quantity;
        //record.created = now.toUTCString();
        if (quantity == 0) {
          state.cartItems.splice(state.cartItems.indexOf(find), 1);
        }
      }
    }
  },
  add_user_checkout_info(state, userInfo) {
    state.userInfo = userInfo;
  },
  add_coupon_to_Cart(state, payload) {
    state.coupons = [];
    state.couponStoreIds = [];
    state.coupons.push(payload.coupon);
    state.couponStoreIds.push(payload.storeId)
  },
  Set_Coupon_Items(state, coupons, couponStoreIds) {
    state.coupons = coupons;
    state.couponStoreIds = couponStoreIds;
  },
  Clear_Coupon_Items(state) {
    state.coupons = [];
    state.couponStoreIds = [];
  },
  remove_coupon_from_Cart(state, couponCode) {
    const record = state.coupons.find(
      (element) => element.CouponCode == couponCode
    );
    const index = state.coupons.indexOf(record);
    state.coupons.splice(index, 1);
    state.couponStoreIds.splice(index, 1);
  },
  remove_coupons_of_other_stores(state, storeId) {
    let index = state.coupons.length;
    while(index > -1) {
      index = state.couponStoreIds.findIndex(e => e != storeId);
      if(index > -1) {
        state.coupons.splice(index, 1);
        state.couponStoreIds.splice(index, 1);
      }
    }
  },

  setTriggerCheckOutPage(state, paylod) {
    state.TriggerCheckOutPage = paylod;
  },
  setPriceTriggerOutcomes(state, payload) {
    state.priceTriggerOutcomes = payload;
  },
  confirmRollInto(state, payload) {
    var pt = null;
    if (payload.orderId) {
      pt = state.priceTriggerOutcomes.find(
        (pt) => pt.ID == payload.id && pt.order == payload.orderId
      );
    } else {
      pt = state.priceTriggerOutcomes.find((pt) => pt.ID == payload.id);
    }
    if (pt) {
      if (!pt.selectedRollIntos) pt.selectedRollIntos = [];
      pt.selectedRollIntos.push({
        index: pt.selectedRollIntos.length, //use length count as index
        selectedModifiers: payload.modifiers,
        isConfirmed: payload.modifiers.length > 0,
      });
    }
    state.forceUpdate = !state.forceUpdate;
  },
  confirmRollIntos(state, payload) {
    var pt = null;
    if (payload.orderId) {
      pt = state.priceTriggerOutcomes.find(
        (pt) => pt.ID == payload.id && pt.order == payload.orderId
      );
    } else {
      pt = state.priceTriggerOutcomes.find((pt) => pt.ID == payload.id);
    }
    pt.selectedRollIntos = payload.rollIntos.map((s, index) => {
      return {
        index: index,
        selectedModifiers: s.modifiers,
        isConfirmed: s.modifiers.length > 0,
      };
    });
    state.forceUpdate = !state.forceUpdate;
  },
};

export const actions = {
  filterCoupons: ({ commit, getters }, storeId) => {
    const coupons = getters.coupons;
    const storeIds = getters.getCouponStoreIds;

    if(coupons.length != storeIds.length) {
      commit("Clear_Coupon_Items");
    }

    commit("remove_coupons_of_other_stores", storeId);
  },
  storeCartInStorage: ({ getters }) => {
    localStorage.setItem(
      "stored-cart-items",
      JSON.stringify({
        cartItems: getters.cartItems,
        coupons: getters.coupons,
        couponStoreIds: getters.getCouponStoreIds,
      })
    );
  },
  loadFromStorage: ({ commit }) => {
    if (localStorage.getItem("stored-cart-items")) {
      var storedData = JSON.parse(localStorage.getItem("stored-cart-items"));
      if (storedData.cartItems && storedData.cartItems.length > 0) {
        commit("Set_Items", storedData.cartItems);

        const setCoupons =
          storedData.coupons
            && storedData.couponStoreIds
            && storedData.coupons.length == storedData.couponStoreIds.length;
        commit(
          "Set_Coupon_Items",
          setCoupons ? storedData.coupons : []
        );
        commit(
          "Set_Coupon_Store_IDs",
          setCoupons ? storedData.couponStoreIds : []
        );
      }
      localStorage.removeItem("stored-cart-items");
    }
  },
  loadCartItemsFromRepository: ({ commit, getters }, storeId) => {
    const storedCartItem = getters.getStoredCartItems(storeId);
    if (
      storedCartItem &&
      storedCartItem.cartItems &&
      storedCartItem.cartItems.length > 0
    ) {
      commit("Set_Items", storedCartItem.cartItems);
      if (storedCartItem.currentMenuId) {
        localStorage.setItem("currentMenuId", storedCartItem.currentMenuId);
      }
    }
  },
  clearCart: ({ commit }) => {
    commit("Set_Items", []);
    commit("Clear_Coupon_Items");
  },
  resetDistance: ({ commit }) => {
    commit("setDistance", 0);
  },
  clearCoupon: ({ commit }) => {
    commit("Clear_Coupon_Items");
  },
  addCouponToCart: ({ commit }, payload) => {
    commit("add_coupon_to_Cart", payload);
  },
  removeCouponfromCart: ({ commit }, coupon) => {
    commit("remove_coupon_from_Cart", coupon);
  },
  applyPriceTriggers({ commit, getters }) {
    commit("setPriceTriggerOutcomes", [...getters.getPriceTriggerOutcomes]);
  },
  applyDeliveryAddress({ commit, getters }, data) {
    try {
      let delivaryAddress = data.address;
      let scheduledTime = data.scheduledTime || getters.getScheduledTime;
      commit("setIsUpdateDeliverAddress", data.isUpdateDeliverAddress);
      if (getters.getIsDelivery) {
        var deliveryOldFullAddress = getters.deliveryAddress
          ? distanceMatrixApi.buildAddress(
              getters.deliveryAddress.StreetAddress,
              getters.deliveryAddress.CityTown,
              getters.deliveryAddress.State,
              getters.deliveryAddress.PostalCode,
              getters.deliveryAddress.Country
            )
          : null;
        var deliveryNewFullAddress = distanceMatrixApi.buildAddress(
          delivaryAddress.StreetAddress,
          delivaryAddress.CityTown,
          delivaryAddress.State,
          delivaryAddress.PostalCode,
          delivaryAddress.Country
        );
        var storeFullAddress = getters.selectedCompany.Location
          ? distanceMatrixApi.buildAddress(
              getters.selectedCompany.Location.Address,
              getters.selectedCompany.Location.Suburb,
              getters.selectedCompany.Location.State,
              getters.selectedCompany.Location.Postcode,
              getters.selectedCompany.Location.Country
            )
          : null;
        //todo
        if (
          !(
            getters.selectedCompany.EnableThirdPartyDelivery &&
            getters.selectedCompany.EnableThirdPartyDelivery.DoorDash
          ) &&
          deliveryOldFullAddress === deliveryNewFullAddress &&
          getters.getSelectedCompanyAddress === storeFullAddress &&
          getters.getDeliveryDistance > 0 &&
          getters.getScheduledTime == scheduledTime
        ) {
          return;
        }
        let requestDateTime = new Date().toISOString();
        commit("setDeliveryAddress", delivaryAddress);
        commit("setScheduledDeliveryTime", scheduledTime);
        commit("setLastRequestDateTime", requestDateTime);
        commit("setDeliveryIsLoading", true);
        if (getters.deliveryAddress.StreetAddress) {
          if (
            getters.selectedCompany.EnableThirdPartyDelivery &&
            getters.selectedCompany.EnableThirdPartyDelivery.DoorDash
          ) {
            var streetAndUnit = addressParse(delivaryAddress.StreetAddress);
            doorDash(
              getters.getTotalPrice,
              getters.selectedCompany.ID,
              streetAndUnit.street,
              getters.deliveryAddress.CityTown,
              getters.deliveryAddress.State,
              getters.deliveryAddress.PostalCode,
              getters.getScheduledTime
            ).then(
              (result) => {
                if (getters.getLastRequestDateTime == requestDateTime) {
                  if (result.data.Success) {
                    commit("setDoorDashDeliveryFee", result.data.Fee);
                    commit("setDuration", result.data.DeliveryDuration * 60);
                    commit("setDeliveryAddressMessage", null);
                    commit("setSelectedCompanyAddress", storeFullAddress);
                    commit("setSubsidyFee", result.data.SubsidyFee);
                  } else {
                    commit("setDoorDashDeliveryFee", 0);
                    commit("setDuration", 0);
                    commit(
                      "setDeliveryAddressMessage",
                      result.data.Status.Message
                    );
                    commit("setSelectedCompanyAddress", storeFullAddress);
                    commit("setSubsidyFee", 0);
                  }
                  commit("setDeliveryIsLoading", false);
                }
              },
              () => {
                if (getters.getLastRequestDateTime == requestDateTime)
                  commit("setDeliveryIsLoading", false);
              }
            );
          } else {
            let distance = 0;
            let duration = 0;
            distanceMatrixApi
              .byAddress(storeFullAddress, deliveryNewFullAddress)
              .then(
                (rows) => {
                  if (getters.getLastRequestDateTime == requestDateTime) {
                    if (rows) {
                      if (rows.elements[0].status == "OK") {
                        distance = Math.ceil(
                          rows.elements[0].distance.value / 1000
                        );
                        duration = rows.elements[0].duration.value;
                        //threshold
                        if (distance == 0) distance = 1;
                        commit("setDeliveryAddressMessage", null);
                      } else {
                        distance = duration = 0;
                      }
                      commit("setDistance", distance);
                      commit("setDuration", duration);
                      commit("setSelectedCompanyAddress", storeFullAddress);
                    }
                    commit("setDeliveryIsLoading", false);
                  }
                },
                () => {
                  commit("setDistance", distance);
                  commit("setDuration", duration);
                  commit("setSelectedCompanyAddress", storeFullAddress);
                  if (getters.getLastRequestDateTime == requestDateTime)
                    commit("setDeliveryIsLoading", false);
                }
              );
          }
        } else {
          commit("setDistance", 0);
          commit("setDuration", 0);
          commit("setSelectedCompanyAddress", null);
          commit("setDeliveryIsLoading", false);
        }
      }
    } catch {
      commit("setDeliveryIsLoading", false);
    }
  },
};

export const getters = {
  checkLocalCartItemsExists: () => {
    try {
      if (localStorage.getItem("stored-cart-items")) {
        var storedData = JSON.parse(localStorage.getItem("stored-cart-items"));
        if (storedData.cartItems && storedData.cartItems.length > 0) {
          return true;
        }
      }
    } catch (ex) {
      console.log(ex);
    }
    return false;
  },
  getTotalPoints: (state, getters) => {
    var tempReward = 0;
    var tempTotalPrice = getters.cartValue;
    const reward = getters.cartItems.filter(
      (element) =>
        element.RewardPoint > 0 && typeof element.RewardPoint != "undefined"
    );
    reward.forEach((element) => {
      tempReward += element.RewardPoint;
      tempTotalPrice -= element.Price;
    });
    return (
      calcLoyaltyPoints(getters.applicableLoyalityRule, tempTotalPrice) +
      tempReward
    );
  },
  getLastRequestDateTime: (state) => {
    return state.lastRequestDateTime;
  },
  getDeliveryIsLoading: (state) => {
    return state.deliveryIsLoading;
  },
  getPopularStatus: (state) => {
    return state.popularStatus;
  },
  getIsDelivery: (state, getters) => {
    if (!getters.selectedCompanyViewConfig.Delivery) return false;
    return state.isDelivery;
  },
  getIsPickup: (state, getters) => {
    if (!getters.selectedCompanyViewConfig.PickUp) return false;
    return state.isPickup;
  },
  getShowDeliveryFee: (state) => {
    return state.showDeliveryFee;
  },
  getOrderPreparationTime: (state, getters) => {
    var OrderPreparationTime =
      getters.selectedCompany.OrderPreparationTime || 0;
    var item = getters.cartItems.sort((a, b) => {
      return b.PreparationTime - a.PreparationTime;
    })[0];
    return OrderPreparationTime > (item ? item.PreparationTime || 0 : 0)
      ? OrderPreparationTime
      : item.PreparationTime;
  },
  getDeliveryDuration: (state, getters) => {
    if (state.duration > 0 && state.deliveryAddress.StreetAddress) {
      var pt = getters.getOrderPreparationTime || 0;
      var pdb = getters.selectedCompany.OrderPreparationDeliveryBuffer || 0;
      var d = state.duration;
      if (d < 60) d = 60;
      var dt = Duration.fromMillis((d + (pt + pdb) * 60) * 1000);
      return dt;
    }
    return null;
  },
  getDeliveryPureDuration: (state) => {
    return state.duration;
  },
  getScheduledTime: (state) => {
    return state.scheduledDeliveryTime;
  },
  getSubsidyFee: (state) => {
    return state.subsidyFee;
  },
  getDeliveryDistance: (state) => {
    return state.distance;
  },
  isUpdateDeliverAddress: (state) => {
    return state.isUpdateDeliverAddress;
  },
  getSelectedCompanyAddress: (state) => {
    return state.selectedCompanyAddress;
  },
  getDeliveryAddressMessage: (state) => {
    return state.deliveryAddressMessage;
  },
  cartItems: (state, getters) => {
    if (getters.storeSelectionAtCheckoutMode && getters.isInCheckout) {
      if (
        getters.selectedStoreMenus
      ) {
        let menu = getters.selectedStoreMenus;
        var Products = menu.Products
          ? Object.entries(menu.Products).map((m) => {
              return {
                ...m[1],
                ProductId: parseInt(m[0]),
              };
            })
          : [];
        var Modifiers = menu.ModifierGroups
          ? Object.values(menu.ModifierGroups).flatMap((x) => x.Modifiers)
          : [];
        let newCartItems = state.cartItems.map((p) => {
          var newProduct = Products.filter((f) => f.ProductCode == p.code)[0];
          let result = null;
          if (newProduct == null) {
            result = {
              ...p,
              unavailable: true,
              disable: true,
            };
          } else if (newProduct.Status == 3) {
            result = {
              ...p,
              soldout: true,
              disable: true,
            };
          } else {
            var extraitems = p.modifiers.map((m) => {
              var find = Modifiers.find((f) => f.Code == m.Code);
              if (find && find.Code != null)
                return {
                  ...m,
                  ID: find.ID,
                };
              else
                return {
                  ...m,
                  disable: true,
                };
            });
            result = {
              ...p,
              id: newProduct.ProductId,
              modifiers: extraitems,
              hQID: p.id,
            };
          }
          return result;
        });
        return newCartItems;
      } else {
        // disable all cartItems
        return state.cartItems.map((p) => {
          return {
            ...p,
            unavailable: true,
            disable: true,
          };
        });
      }
    } else {
      let copy = [...state.cartItems];
      return copy.sort((a, b) => {
        return new Date(b.created) - new Date(a.created);
      });
    }
  },
  costlyCartItems: (state, getters) => {
    let copy = [
      ...getters.cartItems.filter((p) => !p.disable && !p.reedemptionRule),
    ];
    return copy.sort((a, b) => {
      return new Date(b.created) - new Date(a.created);
    });
  },
  cartTotalQuantity: (state, getters) => {
    let copy = [...getters.cartItems.filter((p) => !p.disable)];
    let totalQuantity = 0;
    copy.forEach((element) => {
      totalQuantity += Number(element.quantity);
    });
    return totalQuantity;
  },
  cartValue: (state, getters) => {
    let res = 0;
    res = calculator.calcCartPrice(getters.cartItems.filter((p) => !p.disable));
    var rollintoSum = rollIntoPriceSum(state.priceTriggerOutcomes);
    return positive(res + rollintoSum + 0);
  },
  reedemptionValue: (state, getters) => {
    var value = calculator.calcCartPrice(
      getters.cartItems.filter((p) => !p.disable && p.reedemptionRule)
    );
    return value;
  },
  reedemptionLocalUsedPoints: (state, getters) => {
    var points = 0;
    getters.cartItems
      .filter((p) => !p.disable && p.reedemptionRule)
      .forEach((cartItem) => {
        points += cartItem.reedemptionRule.Point;
      });
    return points;
  },
  reedemptionPoints: (state, getters) => {
    if (getters.dbuser && getters.dbuser.RewardPoints)
      return getters.dbuser.RewardPoints;
    else return 0;
  },
  getredemptionRewardPoints: (state, getters) => {
    var points = 0;
    getters.cartItems
      .filter((p) => !p.disable && !p.reedemptionRule)
      .forEach((cartItem) => {
        points += cartItem.RewardPoint * cartItem.quantity;
      });
    return points;
  },
  currentstore(state) {
    return state.currentstore;
  },
  deliveryAddress(state) {
    return JSON.parse(
      JSON.stringify(state.deliveryAddress ? state.deliveryAddress : {})
    );
  },
  doorDashDeliveryFee(state) {
    return state.doorDashDeliveryFee;
  },
  deliveryFee(state, getters) {
    if (
      getters.getIsDelivery &&
      getters.cartItems.filter((p) => !p.disable).length > 0
    ) {
      if (
        getters.selectedCompany.EnableThirdPartyDelivery &&
        getters.selectedCompany.EnableThirdPartyDelivery.DoorDash
      ) {
        return getters.doorDashDeliveryFee;
      } else {
        var value = getters.cartValue;
        let _deliveryFee = 0;
        if (getters.selectedCompany.FreightFeeRules) {
          for (
            let i = 0;
            i < getters.selectedCompany.FreightFeeRules.length;
            i++
          ) {
            const rule = getters.selectedCompany.FreightFeeRules[i];
            if (
              (!rule.PriceRangeMinimum || value > rule.PriceRangeMinimum) &&
              (!rule.PriceRangeMaximum || value < rule.PriceRangeMaximum)
            ) {
              _deliveryFee = rule.FreightFeeAmount;
              if (rule.FreightFeePerKilometer && getters.deliveryAddress) {
                _deliveryFee =
                  _deliveryFee + state.distance * rule.FreightFeePerKilometer;
              }

              if (
                rule.FreightFeeMinimum &&
                rule.FreightFeeMinimum > _deliveryFee
              ) {
                _deliveryFee = rule.FreightFeeMinimum;
              }
              break;
            }
          }
        }
        return _deliveryFee;
      }
    } else return 0;
  },
  addressOutOfService(state, getters) {
    if (
      getters.getIsDelivery &&
      getters.selectedCompany.Location &&
      getters.deliveryAddress &&
      getters.deliveryAddress.State &&
        ConvertToShortHandState(
          getters.selectedCompany.Location.State
        ).toLowerCase() != getters.deliveryAddress.State.toLowerCase()
    ) {
      return true;
    }
    if (
      getters.getIsDelivery &&
      state.duration == 0 &&
      (getters.selectedCompany.DeliveryRadius ||
        (getters.selectedCompany.EnableThirdPartyDelivery &&
          getters.selectedCompany.EnableThirdPartyDelivery.DoorDash))
    ) {
      return true;
    }
    if (
      getters.getIsDelivery &&
      state.duration > 0 &&
      getters.selectedCompany.DeliveryRadius &&
      getters.selectedCompany.DeliveryRadius > 0
    ) {
      return getters.selectedCompany.DeliveryRadius < state.distance;
    } else {
      return false;
    }
  },
  totaltaxExcludingDicountTax(state, getters) {
    return positive(
      TotalTaxExcludingDicountTax(getters.cartItems.filter((p) => !p.disable))
    );
  },
  totaltax(state, getters) {
    return positive(
      TotalTax(
        getters.cartItems.filter((p) => !p.disable),
        getters.cartValue,
        getters.discount,
        getters.getSurchargeHolidayValidTax
      )
    );
  },
  discountTax(state, getters) {
    return positive(
      DiscountTax(
        TotalTaxExcludingDicountTax(
          getters.cartItems.filter((p) => !p.disable)
        ),
        getters.cartValue,
        getters.discount
      )
    );
  },
  discountExcludingTax(state, getters) {
    return positive(getters.discount - getters.discountTax);
  },
  discount(state, getters) {
    var result =
      couponCalculator.calcAllCoupons(
        state.coupons,
        getters.cartItems.filter((p) => !p.disable)
      ) +
      priceTriggerDiscountsSum(getters.getPriceTriggerOutcomes) +
      0;
    return result;
  },
  used_coupons: (state, getters) => {
    couponCalculator.calcAllCoupons(
      state.coupons,
      getters.cartItems.filter((p) => !p.disable)
    );
    return couponCalculator.used_Coupons;
  },
  getTotalPrice(state, getters) {
    return (
      calcTotalPrice(getters.cartValue, getters.deliveryFee, getters.discount) + 
      getters.getSurchargeAmount
    );
  },
  priceTriggerOutcomes(state) {
    return state.priceTriggerOutcomes;
  },
  coupons: (state) => {
    return state.coupons;
  },
  getCouponStoreIds: (state) => {
    return state.couponStoreIds;
  },
  userCheckoutInfo: (state) => {
    return state.userInfo;
  },
  getStoredCartItems: (state) => (storeId) => {
    return state.cartItemRepository[storeId];
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};
